import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { IoIosCloseCircleOutline, IoMdMenu } from 'react-icons/io';

import styles from './LoginHelper.module.scss';

const users = [
  {
    roles: ['Solicitante', 'Usuario Consulta', 'AUE'],
    username: process.env.REACT_APP_LOGIN_REQUESTER_USER,
    password: process.env.REACT_APP_LOGIN_REQUESTER_PASS
  },
  {
    roles: ['Proveedor Notificador', 'AUE'],
    username: process.env.REACT_APP_LOGIN_NOTIFIER_USER,
    password: process.env.REACT_APP_LOGIN_NOTIFIER_PASS
  },
  {
    roles: ['Aprobador', 'Solicitante', 'Ref. Control de Gestión', 'Ref. Compras', 'AUP'],
    username: process.env.REACT_APP_LOGIN_APPROVER_USER,
    password: process.env.REACT_APP_LOGIN_APPROVER_PASS
  },
  {
    roles: [
      'Inspector',
      'Adm. de Contratos',
      'Control Errores SAP',
      'Ref. Control de Gestión',
      'ADS'
    ],
    username: process.env.REACT_APP_LOGIN_INSPECTOR_USER,
    password: process.env.REACT_APP_LOGIN_INSPECTOR_PASS
  },
  {
    roles: ['Ref. Control de Gestión', 'Proveedor Administrador', 'Proveedor Notificador'],
    username: process.env.REACT_APP_LOGIN_PROVIDER_ADMIN_USER,
    password: process.env.REACT_APP_LOGIN_PROVIDER_ADMIN_PASS
  }
];

const LoginHelper = ({ formik }) => {
  const [isClose, setIsClose] = useState(true);

  const handleClick = useCallback((user) => {
    if (formik) {
      formik.setFieldValue('user', user.username);
      formik.setFieldValue('password', user.password);
      setTimeout(() => {
        formik.setFieldTouched('password');
        formik.setFieldTouched('user');
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.container}>
      {isClose ? (
        <IoMdMenu className={styles.close} onClick={() => setIsClose(false)} size={30} />
      ) : (
        <IoIosCloseCircleOutline
          className={styles.close}
          onClick={() => setIsClose(true)}
          size={30}
        />
      )}
      {!isClose &&
        users.map((user) => (
          <Button key={user.username} onClick={() => handleClick(user)} size="sm">
            {user.roles.join(' / ')}
          </Button>
        ))}
    </div>
  );
};

LoginHelper.propTypes = {
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func.isRequired
  }).isRequired
};

export default LoginHelper;
